import { UserRole } from 'src/shared/api';

export const checkIsPermitted = (
  permittedRoles: UserRole[] = [],
  userRoles: UserRole[] = [],
) => permittedRoles?.some(role => userRoles.includes(role));

export enum UserQueryTypes {  
  admin = 'Админ',
  manager = 'Менеджер',
}
